import { Injectable, signal } from '@angular/core';

@Injectable({
    providedIn: 'root'
})

export class SasSpinnerService {
    isLoading = signal<boolean>(false);
    private activeRequests = 0;

    setLoading(isLoading: boolean) {
        if (isLoading) {
            this.activeRequests++;
            this.isLoading.set(true);
        } else {
            this.activeRequests--;

            if (this.activeRequests === 0) {
                this.isLoading.set(false);
            }
        }
    }
}
